import React from 'react';
import Buildings from '../components/buildings';
import { Face1, Face2, Face3 } from '../components/animations/instructions';
import Privacy from './privacy.register';
import UploadImage from './uploadImage';
import Slide from 'react-reveal/Slide';
import Welcome from './Welcome';
import { GetUrlVars, ResetUrl, isLocalhost } from '../services/data.service';
import { Full as Loader } from '../components/loaders/full';
import { Config } from '../app.config';
import { withTranslation } from "react-i18next";


class Register extends React.Component {
    constructor() {
        super();
        this.state = {
            msg: "",
            hash: "",
            id: "",
            email: "",
            photo: "",
            enrollmentWelcomeHeadline: "",
            enrollmentWelcomeContent: "",
            enrollmentConsentHeadline: "",
            enrollmentConsentContent: "",
            learnMore: "",
            enrollment_language: "en",  // Default language
            steps: [],
            current: null,
            loader: false
        };

        this.on = {
            click: (item, isDirty) => {
                if (isDirty && !item.dirty) return;
                const steps = [...this.state.steps];
                steps.forEach(el => {
                    el.active = el.id === item.id;
                    if (el.active) {
                        el.dirty = true;
                    }
                });
                this.setState({ current: item, steps: steps }, () => {
                    const element = document.getElementById('stepper-facelabs');
                    if (element) {
                        element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
                    }
                });
            }
        };
    }

    componentDidMount() {
        const { i18n } = this.props; // Get i18n instance
        const params = GetUrlVars();
        const isValid = params.hash && params.id;
        const queryLanguage = params.lang; // Check for ?lang= in URL

        const _params = {
            hash: params.hash,
            id: params.id,
            email: params.email
        };

        if (params.contact_mail) {
            window.contact_mail = params.contact_mail;
        }
        if (params.address) {
            window.address = params.address;
        }

        if (params.site) {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            fetch(`${Config.routes.siteDetails}?site=${params.site}`, {
                method: 'get',
                headers: myHeaders,
            })
                .then((res) => res.json())
                .then((result) => {
                    if (result) {
                        const finalLanguage = queryLanguage || result.enrollment_language || "en";

                        // Ensure i18next updates the language
                        if (finalLanguage !== i18n.language) {
                            i18n.changeLanguage(finalLanguage);
                            // Set document language and direction for RTL support
                            document.documentElement.lang = finalLanguage;
                            document.documentElement.dir = finalLanguage === "he" ? "rtl" : "ltr";
                        }

                        this.setState({
                            enrollment_language: finalLanguage,
                            enrollmentWelcomeHeadline: result.enrollment_welcome_headline,
                            enrollmentWelcomeContent: result.enrollment_welcome_content,
                            enrollmentConsentHeadline: result.enrollment_consent_headline,
                            enrollmentConsentContent: result.enrollment_consent_content,
                            learnMore: result.enrollment_learn_more,
                        }, this.setSteps);
                    } else {
                        this.setSteps();
                    }
                })
                .catch((error) => {
                    console.error('Error fetching site details:', error);
                    this.setSteps();
                });
        } else {
            // If no API call, still check for query param
            const finalLanguage = queryLanguage || "en";

            if (finalLanguage !== i18n.language) {
                i18n.changeLanguage(finalLanguage);
                // Set document language and direction for RTL support
                document.documentElement.lang = finalLanguage;
                document.documentElement.dir = finalLanguage === "he" ? "rtl" : "ltr";
            }

            this.setState({
                enrollment_language: finalLanguage,
            }, this.setSteps());
        }

        if (isValid) {
            this.setState({
                hash: _params.hash,
                id: _params.id,
                email: _params.email
            });
        }

        if (!isLocalhost()) {
            ResetUrl('/register');
        }
    }


    setSteps = () => {
        const { t } = this.props;
        const learnMoreSite = this.state.learnMore || "https://proptech.ai";

        const welcome = {
            id: 0,
            component: <Welcome title={this.state.enrollmentWelcomeHeadline} content={this.state.enrollmentWelcomeContent} />,
            text: "",
            btnTxt: t("btn_lets_go"),
            onClick: () => this.on.click(this.state.steps[1])
        };
        const thanks = {
            id: 5,
            component: <Face3 />,
            text: (
                <div className="flex flex-col text-center w-full mt-20">
                    <h1 style={{maxHeight: "70px"}}
                        className="sm:text-3xl text-2xl font-medium title-font text-gray-900">
                        {t("thank_you")}
                    </h1>
                    <h2 className="text-xs text-blue-900 tracking-widest font-medium title-font">
                        {t("registration_completed")}
                    </h2>
                    <h2 className="text-xs text-blue-900 tracking-widest font-medium title-font">
                        <a style={{color: "inherit"}}
                           href={learnMoreSite}>{t("learn_more", {site: learnMoreSite})}</a>
                    </h2>
                </div>
    )
    };
    const privacy = {
        id: 1,
            dirty: true,
            component: <Privacy title={this.state.enrollmentConsentHeadline} content={this.state.enrollmentConsentContent} />,
            btnTxt: t("btn_agree"),
            onClick: () => this.on.click(this.state.steps[2]),
            active: true
        };

        this.setState({
            steps: [welcome, privacy, {
                id: 2, component: <Face1 />, btnTxt: t("btn_next"), onClick: () => this.on.click(this.state.steps[3])
            },
                {
                    id: 3, component: <Face2 />, btnTxt: t("btn_next"), onClick: () => this.on.click(this.state.steps[4])
                },
                {
                    id: 4, component: <UploadImage onChange={(photo) => this.setState({ photo })} onSubmit={this.sendForm} />,
                    onClick: () => { }
                }, thanks],
            current: welcome
        });
    }

    sendForm = () => {
        const state = this.state;
        const isValid = [state.hash, state.id, state.photo].filter(v => !v).length === 0;
        if (isValid) {
            this.setState({ loader: true });
            const data = {
                hash: state.hash,
                email: state.email,
                id: state.id,
                photo: state.photo
            };
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            fetch(Config.routes.register, {
                method: 'post',
                headers: myHeaders,
                body: JSON.stringify(data)
            }).then((res) => {
                this.setState({ loader: false });
                if (res.status === 200) {
                    this.on.click(this.state.steps[5]);
                    this.setState({ current: this.state.steps[5], msg: "" });
                } else {
                    return res.json();
                }
            }).then(result => {
                if (result && typeof result.msg === "string") {
                    this.setState({ msg: result.msg });
                }
            });
        }
    }

    render() {
        const { t } = this.props;
        return (
            <main className="bg-white font-open-sans">
                <section className="text-gray-700 body-font">
                    <div className="text-center mx-auto px-6 sm:px-12 flex flex-col-reverse sm:flex-row relative">
                        <div style={{ minHeight: '90vh' }} className="sm:w-12/12 xl:w-12/12 flex flex-col items-center sm:items-center sm:text-center mx-auto sm:mt-0 relative z-10 mb-16 sm:mb-0">
                            {this.state.current && this.state.current.text ? <div>{this.state.current.text}</div> : null}
                            <div className="mt-5">
                                {this.state.current && this.state.current.component}
                            </div>
                            <Slide bottom>
                                <div>
                                    {this.state.current && this.state.current.btnTxt ? <button onClick={this.state.current.onClick} className="flashing sm:w-12/12 ml-4 block text-white bg-blue-900 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg">{this.state.current.btnTxt}</button> : null}
                                </div>
                            </Slide>
                            {this.state.msg ? <h1 style={{ color: 'red' }} className="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">{t("error")}:{this.state.msg}</h1> : null}
                        </div>
                        <Buildings />
                    </div>
                </section>
                {this.state.loader ? <Loader /> : null}
            </main>
        );
    }
}

export default withTranslation()(Register);
